import React from 'react';
import { ContactForm } from './ContactForm';
import { CONTACT_INFO, SERVICES, SOCIAL_LINKS } from '../data/siteContent';

const Contact = () => (
  <section id="contact" className="py-16 sm:py-20 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12 sm:mb-16">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-[#001B2A] mb-4">
          Get In Touch
        </h2>
        <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
          Have questions? We'd love to hear from you.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-12">
        <ContactForm />

        <div className="space-y-8">
          <div>
            <h3 className="text-2xl font-serif font-bold text-[#001B2A] mb-6">
              Contact Information
            </h3>
            <p className="text-gray-600 mb-8">
              Reach out for consultations, at-home service shows, or event bookings. Available online and across the country for special events!
            </p>
          </div>

          <div className="space-y-6">
            {CONTACT_INFO.map(({ icon: Icon, title, lines, note }) => (
              <div key={title} className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-[#E6D7B3] rounded-lg flex items-center justify-center">
                  <Icon className="h-6 w-6 text-[#001B2A]" />
                </div>
                <div>
                  <h4 className="font-semibold text-[#001B2A] mb-1">{title}</h4>
                  {lines.map((line) => (
                    <p key={line} className="text-gray-600">{line}</p>
                  ))}
                  {note && <p className="text-sm text-gray-500 mt-1">{note}</p>}
                </div>
              </div>
            ))}
          </div>

          {/* Follow Johnnie */}
          <div className="bg-gray-50 rounded-lg p-6">
            <h4 className="font-serif font-bold text-xl text-[#001B2A] mb-4">Follow The Bow Tie Guy</h4>
            <div className="space-y-3">
              {SOCIAL_LINKS.map((s) => (
                <a
                  key={s.id}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`contact-social-${s.id}`}
                  className="flex items-center justify-between text-sm text-gray-700 hover:text-[#7B1E2B] transition-colors"
                >
                  <span className="font-semibold">{s.label}</span>
                  <span className="text-gray-500">{s.handle}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Services Offered */}
          <div className="bg-gradient-to-br from-[#001B2A] to-[#7B1E2B] rounded-lg p-6 text-white">
            <h4 className="font-serif font-bold text-xl mb-4">Services Available</h4>
            <div className="space-y-3">
              {SERVICES.map((service) => (
                <div key={service.title} className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-[#E6D7B3] rounded-full mt-2"></div>
                  <div>
                    <p className="font-semibold">{service.title}</p>
                    <p className="text-sm text-gray-200">{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-6 pt-4 border-t border-white/20 text-center">
              <p className="text-sm italic">Contact us to schedule your personalized consultation or event</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Contact;
